module.exports = __webpack_public_path__ + "img/report_10-2.470c05bc.png";